import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const Impressum = () => {
  return (
    <LegalPageLayout
      title="Impressum (Legal Notice)"
      intro="Information provided in accordance with Sec. 5 German Telemedia Act (TMG) and Sec. 18 (2) German State Media Treaty (MStV)."
      lastUpdated="5 June 2024"
    >
      <section className="flux-legal-section">
        <h2>Responsible Entity</h2>
        <p>
          MAROSCH UG (haftungsbeschränkt)
          <br />
          Bunzlauer Str. 8
          <br />
          80992 Munich
          <br />
          Germany
        </p>
        <p>
          Represented by: Dr. Ronny Schüritz
          <br />
          Managing Director: Dr. Ronny Schüritz
        </p>
        <p>
          Contact:
          <br />
          E-mail: <a href="mailto:ronny@fluxspaces.app">ronny@fluxspaces.app</a>
          <br />
          Alternative e-mail: <a href="mailto:ronny@marosch-creates.com">ronny@marosch-creates.com</a>
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Commercial Register Details</h2>
        <ul>
          <li>Commercial register number: HRB 287788</li>
          <li>Register court: Amtsgericht Munich</li>
          <li>VAT ID pursuant to Sec. 27a German VAT Act: DE365693775</li>
          <li>Professional regulations: Not applicable</li>
        </ul>
      </section>

      <section className="flux-legal-section">
        <h2>Editorial Responsibility (Sec. 18 (2) MStV)</h2>
        <p>
          Dr. Ronny Schüritz
          <br />
          Bunzlauer Str. 8
          <br />
          80992 Munich
          <br />
          Germany
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Liability for Contents</h2>
        <p>
          As a service provider, we are responsible for our own content on these pages in
          accordance with general laws pursuant to Sec. 7 (1) TMG. According to Sec. 8 to 10
          TMG, we are not obligated to monitor transmitted or stored third-party information
          or to investigate circumstances that indicate unlawful activity. Obligations to
          remove or block the use of information under general law remain unaffected. Any
          liability in this respect is, however, only possible from the point in time at
          which we become aware of a specific infringement. Upon notification of such
          violations, we will remove the content immediately.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Liability for Links</h2>
        <p>
          Our offer may contain links to external websites of third parties on whose
          contents we have no influence. Therefore, we cannot assume any liability for these
          external contents. The respective provider or operator of the pages is always
          responsible for the content of the linked pages. The linked pages were checked for
          possible legal violations at the time of linking. Illegal contents were not
          recognizable at the time of linking. A permanent control of the linked pages is
          not reasonable without concrete indications of a legal violation. If we become
          aware of any infringements, we will remove such links immediately.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Copyright</h2>
        <p>
          The content and works created by the site operators on these pages are subject to
          German copyright law. The duplication, processing, distribution, and any kind of
          exploitation outside the limits of copyright require the written consent of the
          respective author or creator. Downloads and copies of this site are only permitted
          for private, non-commercial use. Insofar as the content on this site was not
          created by the operator, the copyrights of third parties are respected. In
          particular, third-party content is marked as such. Should you nevertheless become
          aware of a copyright infringement, please inform us accordingly. Upon
          notification of violations, we will remove such content immediately.
        </p>
      </section>
    </LegalPageLayout>
  );
};

export default Impressum;
